import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('pb_auth_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authApi = {
  loginAdmin: (username, password) =>
    api.post('/api/auth/login/', { username, password }).then(r => r.data),
  loginCourt: (court_pin) =>
    api.post('/api/auth/login/', { court_pin }).then(r => r.data),
  me: () => api.get('/api/auth/me/').then(r => r.data),
  logout: () => api.post('/api/auth/logout/').then(r => r.data),
};

export const courtsApi = {
  list: () => api.get('/api/courts/').then(r => r.data),
  statusOverview: () => api.get('/api/courts/status_overview/').then(r => r.data),
  update: (id, data) => api.patch(`/api/courts/${id}/`, data).then(r => r.data),
  kioskIdentify: (token) =>
    api.get('/api/courts/kiosk/identify/', { params: { token } }).then(r => r.data),
  kioskDevices: () => api.get('/api/courts/kiosk/devices/').then(r => r.data),
  kioskDeviceCreate: (data) => api.post('/api/courts/kiosk/devices/', data).then(r => r.data),
  kioskDeviceUpdate: (id, data) =>
    api.patch(`/api/courts/kiosk/devices/${id}/`, data).then(r => r.data),
  kioskDeviceDelete: (id) => api.delete(`/api/courts/kiosk/devices/${id}/`),
};

export const recordingsApi = {
  start: (courtId, playerEmail, extraEmails = []) =>
    api.post('/api/recordings/start/', {
      court_id: courtId,
      player_email: playerEmail,
      extra_emails: extraEmails,
    }).then(r => r.data),
  stop: (sessionId) =>
    api.post('/api/recordings/stop/', { session_id: sessionId }, { timeout: 60000 }).then(r => r.data),
  getActive: (courtId) =>
    api.get('/api/recordings/active/', { params: { court_id: courtId } }).then(r => r.data),
  get: (sessionId) =>
    api.get(`/api/recordings/sessions/${sessionId}/`).then(r => r.data),
  status: (sessionId) =>
    api.get(`/api/recordings/sessions/${sessionId}/status/`).then(r => r.data),
  list: (params = {}) =>
    api.get('/api/recordings/sessions/', { params }).then(r => r.data),
  resendEmail: (sessionId, emails = null) =>
    api.post(`/api/recordings/sessions/${sessionId}/resend-email/`, emails ? { emails } : {}).then(r => r.data),
  qrCodeUrl: (sessionId) => `${API_BASE}/api/recordings/sessions/${sessionId}/qrcode/`,
  previewUrl: (courtId) => `${API_BASE}/api/recordings/courts/${courtId}/preview/`,
};

export const watchApi = {
  get: (code) => api.get(`/api/recordings/watch/${code}/`).then(r => r.data),
};

export const agentApi = {
  status: () => api.get('/api/agent/status/').then(r => r.data),
};

export const storageApi = {
  stats: () => api.get('/api/storage/stats/').then(r => r.data),
  cleanup: () => api.post('/api/storage/cleanup/').then(r => r.data),
};

export default api;
